(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3459],{

/***/ 66242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card_Card; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/base/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(27192);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js + 1 modules
var useThemeProps = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(55113);
// EXTERNAL MODULE: ./node_modules/@mui/base/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(28979);
// EXTERNAL MODULE: ./node_modules/@mui/base/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(76087);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Card/cardClasses.js

function getCardUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiCard', slot);
}
const cardClasses = (0,generateUtilityClasses/* default */.Z)('MuiCard', ['root']);
/* harmony default export */ var Card_cardClasses = ((/* unused pure expression or super */ null && (cardClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Card/Card.js


const _excluded = ["className", "raised"];











const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getCardUtilityClass, classes);
};

const CardRoot = (0,styled/* default */.ZP)(Paper/* default */.Z, {
  name: 'MuiCard',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(() => {
  return {
    overflow: 'hidden'
  };
});
const Card = /*#__PURE__*/react.forwardRef(function Card(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCard'
  });

  const {
    className,
    raised = false
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    raised
  });

  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    elevation: raised ? 8 : undefined,
    ref: ref,
    ownerState: ownerState
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Card_Card = (Card);

/***/ }),

/***/ 36429:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login",
      function () {
        return __webpack_require__(70146);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 65907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Image; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72679);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87357);





// @mui
 //
// ----------------------------------------------------------------------
Image.propTypes = {
    disabledEffect: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
    effect: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
    ratio: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf([
        "4/3",
        "3/4",
        "6/4",
        "4/6",
        "16/9",
        "9/16",
        "21/9",
        "9/21",
        "1/1",
        "16/8"
    ]),
    sx: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().object)
};
function Image(_param) {
    var ratio = _param.ratio, _disabledEffect = _param.disabledEffect, disabledEffect = _disabledEffect === void 0 ? false : _disabledEffect, _effect = _param.effect, effect = _effect === void 0 ? "blur" : _effect, sx = _param.sx, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "ratio",
        "disabledEffect",
        "effect",
        "sx"
    ]);
    if (ratio) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            component: "span",
            sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                width: 1,
                lineHeight: 0,
                display: "block",
                overflow: "hidden",
                position: "relative",
                pt: getRatio(ratio),
                "& .wrapper": {
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    lineHeight: 0,
                    position: "absolute",
                    backgroundSize: "cover !important"
                }
            }, sx),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                component: react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_1__.LazyLoadImage,
                wrapperClassName: "wrapper",
                effect: disabledEffect ? undefined : effect,
                placeholderSrc: "/icons/img_placeholder.svg",
                sx: {
                    width: 1,
                    height: 1,
                    objectFit: "cover"
                }
            }, other))
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        component: "span",
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            lineHeight: 0,
            display: "block",
            overflow: "hidden",
            "& .wrapper": {
                width: 1,
                height: 1,
                backgroundSize: "cover !important"
            }
        }, sx),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            component: react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_1__.LazyLoadImage,
            wrapperClassName: "wrapper",
            effect: disabledEffect ? undefined : effect,
            placeholderSrc: "/icons/img_placeholder.svg",
            sx: {
                height: "auto",
                maxWidth: 1,
                objectFit: "cover"
            }
        }, other))
    });
}
// ----------------------------------------------------------------------
function getRatio() {
    var ratio = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "1/1";
    return ({
        "4/3": "calc(100% / 4 * 3)",
        "3/4": "calc(100% / 3 * 4)",
        "6/4": "calc(100% / 6 * 4)",
        "4/6": "calc(100% / 4 * 6)",
        "16/9": "calc(100% / 16 * 9)",
        "9/16": "calc(100% / 9 * 16)",
        "21/9": "calc(100% / 21 * 9)",
        "9/21": "calc(100% / 9 * 21)",
        "1/1": "100%",
        "16/8": "calc(100% / 16 * 8)",
        "8/16": "calc(100% / 8 * 16)"
    })[ratio];
}


/***/ }),

/***/ 6417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87357);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hooks_useSettings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40571);





// @mui



// ----------------------------------------------------------------------
var LogoText = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(param, ref) {
    var _disabledLink = param.disabledLink, disabledLink = _disabledLink === void 0 ? false : _disabledLink, sx = param.sx;
    var themeMode = (0,_hooks_useSettings__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().themeMode;
    var logo = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        ref: ref,
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            width: 168,
            height: 40,
            cursor: "pointer"
        }, sx),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
            alt: "Hackerthon.net",
            src: themeMode == "light" ? "/logo/logo-black.png" : "/logo/logo-white.png",
            width: 168,
            height: 40
        })
    });
    if (disabledLink) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: logo
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: "/",
        children: logo
    });
});
LogoText.propTypes = {
    disabledLink: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    sx: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().object)
};
/* harmony default export */ __webpack_exports__["Z"] = (LogoText);


/***/ }),

/***/ 84818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MenuPopover; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11496);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14564);






// @mui


// ----------------------------------------------------------------------
var ArrowStyle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)("span")(function(param) {
    var arrow = param.arrow, theme = param.theme;
    var SIZE = 12;
    var POSITION = -(SIZE / 2);
    var borderStyle = "solid 1px ".concat(theme.palette.grey[50012]);
    var topStyle = {
        borderRadius: "0 0 3px 0",
        top: POSITION,
        borderBottom: borderStyle,
        borderRight: borderStyle
    };
    var bottomStyle = {
        borderRadius: "3px 0 0 0",
        bottom: POSITION,
        borderTop: borderStyle,
        borderLeft: borderStyle
    };
    var leftStyle = {
        borderRadius: "0 3px 0 0",
        left: POSITION,
        borderTop: borderStyle,
        borderRight: borderStyle
    };
    var rightStyle = {
        borderRadius: "0 0 0 3px",
        right: POSITION,
        borderBottom: borderStyle,
        borderLeft: borderStyle
    };
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, theme.breakpoints.up("sm"), {
        zIndex: 1,
        width: SIZE,
        height: SIZE,
        content: "''",
        position: "absolute",
        transform: "rotate(-135deg)",
        background: theme.palette.background.paper
    }), arrow === "top-left" && (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, topStyle), {
        left: 20
    }), arrow === "top-center" && (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, topStyle), {
        left: 0,
        right: 0,
        margin: "auto"
    }), arrow === "top-right" && (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, topStyle), {
        right: 20
    }), arrow === "bottom-left" && (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, bottomStyle), {
        left: 20
    }), arrow === "bottom-center" && (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, bottomStyle), {
        left: 0,
        right: 0,
        margin: "auto"
    }), arrow === "bottom-right" && (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, bottomStyle), {
        right: 20
    }), arrow === "left-top" && (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, leftStyle), {
        top: 20
    }), arrow === "left-center" && (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, leftStyle), {
        top: 0,
        bottom: 0,
        margin: "auto"
    }), arrow === "left-bottom" && (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, leftStyle), {
        bottom: 20
    }), arrow === "right-top" && (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, rightStyle), {
        top: 20
    }), arrow === "right-center" && (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, rightStyle), {
        top: 0,
        bottom: 0,
        margin: "auto"
    }), arrow === "right-bottom" && (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, rightStyle), {
        bottom: 20
    }));
});
// ----------------------------------------------------------------------
MenuPopover.propTypes = {
    sx: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().object),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node),
    disabledArrow: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
    arrow: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf([
        "top-left",
        "top-center",
        "top-right",
        "bottom-left",
        "bottom-center",
        "bottom-right",
        "left-top",
        "left-center",
        "left-bottom",
        "right-top",
        "right-center",
        "right-bottom", 
    ])
};
function MenuPopover(_param) {
    var children = _param.children, _arrow = _param.arrow, arrow = _arrow === void 0 ? "top-right" : _arrow, disabledArrow = _param.disabledArrow, sx = _param.sx, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "children",
        "arrow",
        "disabledArrow",
        "sx"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "right"
        },
        transformOrigin: {
            vertical: "top",
            horizontal: "right"
        },
        PaperProps: {
            sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                p: 1,
                width: 200,
                overflow: "inherit"
            }, sx)
        }
    }, other), {
        children: [
            !disabledArrow && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ArrowStyle, {
                arrow: arrow
            }),
            children
        ]
    }));
}


/***/ }),

/***/ 82771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87357);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);






// next

// @mui


// ----------------------------------------------------------------------
var Page = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var children = _param.children, _title = _param.title, title = _title === void 0 ? "" : _title, _description = _param.description, description = _description === void 0 ? "" : _description, _imagePath = _param.imagePath, imagePath = _imagePath === void 0 ? "https://hackerthon.net/image/banner.jpg" : _imagePath, meta = _param.meta, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children",
        "title",
        "description",
        "imagePath",
        "meta"
    ]);
    var asPath = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().asPath;
    var pathname = "https://hackerthon.net".concat(asPath);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                        children: [
                            "Hackerthon.net | ",
                            title
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "article"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: imagePath || "https://hackerthon.net/image/banner.jpg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: pathname
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: "hackerthon.net"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "fb:app_id",
                        content: "632228391747595"
                    }),
                    meta
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                ref: ref
            }, other), {
                children: children
            }))
        ]
    });
});
Page.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().node.isRequired),
    title: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    description: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    imagePath: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    meta: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().node)
};
/* harmony default export */ __webpack_exports__["Z"] = (Page);


/***/ }),

/***/ 77364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export useCurrentRole */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _contexts_FirebaseContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52036);

//

// ----------------------------------------------------------------------
var useAuth = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_contexts_FirebaseContext__WEBPACK_IMPORTED_MODULE_1__/* .AuthContext */ .V);
    if (!context) throw new Error("Auth context must be use inside AuthProvider");
    return context;
};
var useCurrentRole = function() {
    var user = useAuth().user;
    var roles = user.roles;
    return roles === null || roles === void 0 ? void 0 : roles.map(function(r) {
        return r.name;
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (useAuth);


/***/ }),

/***/ 9582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LanguagePopover; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18972);
/* harmony import */ var _hooks_useLocales__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9671);
/* harmony import */ var _components_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65907);
/* harmony import */ var _components_MenuPopover__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84818);
/* harmony import */ var _components_animate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80104);



// @mui

// hooks

// components



// ----------------------------------------------------------------------
function LanguagePopover() {
    var ref = (0,_hooks_useLocales__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(), allLang = ref.allLang, currentLang = ref.currentLang, onChangeLang = ref.onChangeLang;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), open = ref1[0], setOpen = ref1[1];
    var handleOpen = function(event) {
        setOpen(event.currentTarget);
    };
    var handleClose = function() {
        setOpen(null);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_animate__WEBPACK_IMPORTED_MODULE_5__/* .IconButtonAnimate */ .w_, {
                onClick: handleOpen,
                sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                    width: 40,
                    height: 40
                }, open && {
                    bgcolor: "action.selected"
                }),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    disabledEffect: true,
                    src: currentLang.icon,
                    alt: currentLang.label
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MenuPopover__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                open: Boolean(open),
                anchorEl: open,
                onClose: handleClose,
                sx: {
                    mt: 1.5,
                    ml: 0.75,
                    width: 180,
                    "& .MuiMenuItem-root": {
                        px: 1,
                        typography: "body2",
                        borderRadius: 0.75
                    }
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    spacing: 0.75,
                    children: allLang.map(function(option) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            selected: option.value === currentLang.value,
                            onClick: function() {
                                onChangeLang(option.value);
                                handleClose();
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    disabledEffect: true,
                                    alt: option.label,
                                    src: option.icon,
                                    sx: {
                                        width: 28,
                                        height: 19,
                                        mr: 2
                                    }
                                }),
                                option.label
                            ]
                        }, option.value);
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 70146:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Login; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 1 modules
var Link = __webpack_require__(50122);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(27948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./src/routes/paths.js
var paths = __webpack_require__(76939);
// EXTERNAL MODULE: ./src/hooks/useAuth.js
var useAuth = __webpack_require__(77364);
// EXTERNAL MODULE: ./src/hooks/useResponsive.js
var useResponsive = __webpack_require__(55102);
// EXTERNAL MODULE: ./src/components/Image.js
var Image = __webpack_require__(65907);
// EXTERNAL MODULE: ./src/components/Page.js
var Page = __webpack_require__(82771);
// EXTERNAL MODULE: ./src/components/LogoText.js
var LogoText = __webpack_require__(6417);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/guards/GuestGuard.js



// next

// hooks

// routes

// ----------------------------------------------------------------------
GuestGuard.propTypes = {
    children: (prop_types_default()).node
};
function GuestGuard(param) {
    var children = param.children;
    var push = (0,router.useRouter)().push;
    var isAuthenticated = (0,useAuth/* default */.Z)().isAuthenticated;
    (0,react.useEffect)(function() {
        if (isAuthenticated) {
            push("".concat(paths/* PATH_AUTH.profile */.EE.profile));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isAuthenticated
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
}

// EXTERNAL MODULE: ./src/hooks/useLocales.js + 5 modules
var useLocales = __webpack_require__(9671);
// EXTERNAL MODULE: ./src/layouts/main/LanguagePopover.js
var LanguagePopover = __webpack_require__(9582);
// EXTERNAL MODULE: ./src/sections/auth/AuthFirebaseSocial.js
var AuthFirebaseSocial = __webpack_require__(56212);
// EXTERNAL MODULE: ./src/sections/auth/LoginForm.js
var LoginForm = __webpack_require__(50249);
;// CONCATENATED MODULE: ./src/pages/login.js



// @mui


// routes

// hooks


// components


// sections






// ----------------------------------------------------------------------
var RootStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({}, theme.breakpoints.up("md"), {
        display: "flex"
    });
});
var HeaderStyle = (0,styled/* default */.ZP)("header")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        top: 0,
        zIndex: 9,
        lineHeight: 0,
        width: "100%",
        display: "flex",
        alignItems: "center",
        position: "absolute",
        padding: theme.spacing(3),
        justifyContent: "space-between"
    }, theme.breakpoints.up("md"), {
        alignItems: "flex-start",
        padding: theme.spacing(7, 5, 0, 7)
    });
});
var SectionStyle = (0,styled/* default */.ZP)(Card/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        width: "100%",
        maxWidth: 464,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        margin: theme.spacing(2, 0, 2, 2)
    };
});
var ContentStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return {
        maxWidth: 480,
        margin: "auto",
        display: "flex",
        minHeight: "100vh",
        flexDirection: "column",
        justifyContent: "center",
        padding: theme.spacing(12, 0)
    };
});
// ----------------------------------------------------------------------
function Login() {
    var method = (0,useAuth/* default */.Z)().method;
    var smUp = (0,useResponsive/* default */.Z)("up", "sm");
    var mdUp = (0,useResponsive/* default */.Z)("up", "md");
    var translate = (0,useLocales/* default */.Z)().translate;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GuestGuard, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
            title: translate("label.signinToJmaster"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootStyle, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderStyle, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoText/* default */.Z, {}),
                            smUp && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: "body2",
                                sx: {
                                    mt: {
                                        md: -2
                                    }
                                },
                                children: [
                                    translate("label.dontHaveAccount"),
                                    " ",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        variant: "subtitle2",
                                        href: paths/* PATH_AUTH.register */.EE.register,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                            href: paths/* PATH_AUTH.register */.EE.register,
                                            children: translate("label.getStarted")
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    mdUp && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionStyle, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h3",
                                sx: {
                                    px: 5,
                                    mt: 10,
                                    mb: 5
                                },
                                children: "Hi, Welcome Back"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                alt: "login",
                                src: "/image/login_banner.png"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        maxWidth: "sm",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentStyle, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                    direction: "row",
                                    alignItems: "center",
                                    sx: {
                                        mb: 5
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                            sx: {
                                                flexGrow: 1
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "h4",
                                                    gutterBottom: true,
                                                    children: translate("label.signinToJmaster")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    sx: {
                                                        color: "text.secondary"
                                                    },
                                                    children: translate("label.enterDetailsBelow")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguagePopover/* default */.Z, {})
                                    ]
                                }),
                                method === "firebase" && /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthFirebaseSocial/* default */.Z, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginForm/* default */.Z, {}),
                                !smUp && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                    variant: "body2",
                                    align: "center",
                                    sx: {
                                        mt: 3
                                    },
                                    children: [
                                        translate("label.dontHaveAccount"),
                                        " ",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            variant: "subtitle2",
                                            href: paths/* PATH_AUTH.register */.EE.register,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                href: paths/* PATH_AUTH.register */.EE.register,
                                                children: translate("label.getStarted")
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 76939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EE": function() { return /* binding */ PATH_AUTH; },
/* harmony export */   "U6": function() { return /* binding */ PATH_RESOURCE; },
/* harmony export */   "ko": function() { return /* binding */ PATH_PAGE; },
/* harmony export */   "zU": function() { return /* binding */ PATH_HACKERTHON; }
/* harmony export */ });
// ----------------------------------------------------------------------
var PATH_AUTH = {
    login: "/login",
    register: "/register",
    profile: "/auth/profile",
    setting: "/auth/setting",
    dashboard: "/auth/dashboard"
};
var PATH_PAGE = {
    home: "/",
    about: "/about-us",
    terms: "/terms",
    privacy: "/privacy"
};
var PATH_HACKERTHON = {
    exercises: "/exercises",
    practice: "/practices",
    project: "/projects",
    ide: "/online-ide",
    explorer: "/explorer",
    exams: "/exams",
    ranking: "/ranking"
};
var PATH_RESOURCE = {
    blogs: "/blogs",
    business: "/business",
    questions: "/questions",
    forums: "/forums"
};


/***/ }),

/***/ 56212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AuthFirebaseSocial; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83321);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67720);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15861);
/* harmony import */ var _components_Iconify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34444);
/* harmony import */ var _hooks_useAuth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77364);
// @mui


// components


// ----------------------------------------------------------------------
function AuthFirebaseSocial() {
    var ref = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(), loginWithGoogle = ref.loginWithGoogle, loginWithGithub = ref.loginWithGithub, loginWithApple = ref.loginWithApple;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                direction: "row",
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        fullWidth: true,
                        size: "large",
                        color: "inherit",
                        variant: "outlined",
                        onClick: loginWithGoogle,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Iconify__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            icon: "eva:google-fill",
                            color: "#DF3E30",
                            width: 24,
                            height: 24
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        fullWidth: true,
                        size: "large",
                        color: "inherit",
                        variant: "outlined",
                        onClick: loginWithApple,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Iconify__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            icon: "ic:sharp-apple",
                            color: "#666",
                            width: 24,
                            height: 24
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                sx: {
                    my: 3
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    variant: "body2",
                    sx: {
                        color: "text.secondary"
                    },
                    children: "OR"
                })
            })
        ]
    });
}


/***/ }),

/***/ 50249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LoginForm; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var firebase_compat_app__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1902);
/* harmony import */ var firebase_compat_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79085);
/* harmony import */ var react_firebaseui_StyledFirebaseAuth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75913);
/* harmony import */ var react_firebaseui_StyledFirebaseAuth__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_firebaseui_StyledFirebaseAuth__WEBPACK_IMPORTED_MODULE_3__);




function LoginForm() {
    var uiConfig = {
        // Popup signin flow rather than redirect flow.
        signInFlow: "popup",
        signInSuccessUrl: "/",
        signInOptions: [
            {
                provider: firebase_compat_app__WEBPACK_IMPORTED_MODULE_1__/* ["default"].auth.EmailAuthProvider.PROVIDER_ID */ .Z.auth.EmailAuthProvider.PROVIDER_ID,
                signInMethod: firebase_compat_app__WEBPACK_IMPORTED_MODULE_1__/* ["default"].auth.EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD */ .Z.auth.EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD,
                requireDisplayName: true,
                forceSameDevice: true
            }, 
        ],
        tosUrl: "https://hackerthon.net/terms",
        privacyPolicyUrl: "https://hackerthon.net/privacy"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_firebaseui_StyledFirebaseAuth__WEBPACK_IMPORTED_MODULE_3___default()), {
        uiConfig: uiConfig,
        firebaseAuth: firebase_compat_app__WEBPACK_IMPORTED_MODULE_1__/* ["default"].auth */ .Z.auth()
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8717,5101,8208,9774,2888,179], function() { return __webpack_exec__(36429); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);